import { PageState } from 'models/PageState';

export const selectIsBot = ({ appShell }: PageState) => appShell.isBot;
